import * as TYPES from './type';
export default {
  //用户登录
  [TYPES.LOGIN_CODE](state, { result }) {
    state.code = result.result
  },
  [TYPES.USER_LOGIN](state, { result }) {
    state.login = result.result
  },
  [TYPES.USER_INFO](state, { result }) {
    state.userInfo = result.result
  },
  [TYPES.USER_INFO_EDIT](state, { result, type }) {
    state.userEdit[type] = result.result
  },
  [TYPES.USER_INFO_INQUIRE](state, { result }) {
    state.userInfoInquire = result.result
  },
  //首页左上
  [TYPES.TEAMESSAGE](state, { result }) {
    state.teaMessageList = result.result
  },
  //首页中间
  [TYPES.CENTREMESSAGE](state, { result }) {
    state.centreMessageList = result.result
  },
  //首页右上
  [TYPES.COURSEMESSAGE](state, { result }) {
    state.courseMessageList = result.result
  },
  //首页底部
  [TYPES.BASEMESSAGE](state, { result }) {
    state.baseMessageList = result.result
  },
  //首页课程评价列表
  [TYPES.BASE_EVALUATION_LIST](state, { result }) {
    state.baseEvaluationList = result.result
  },
  //首页课程评价删除
  [TYPES.BASE_EVALUATION_DEL](state, { result }) {
    state.baseEvaluationDel = result.result
  },

  [TYPES.JXTALK_LIST](state, { result }) {
    state.jxtalkList = result.result
  },
  // 获取登录用户分值
  [TYPES.USER_LOGIN_SCORE](state, { result }) {
    state.userLoginScore = result.result
  },
  // 添加list集合
  [TYPES.USER_LIST_GATHER](state, { result }) {
    state.userListGather = result.result
  },

  [TYPES.USER_THIRD_LOGIN](state, { result, type }) {
    state.third[type] = result.result
  },
   // 密码正则校验
   [TYPES.USER_PASSWORDVERIFY](state, { result, type }) {
    state.userPasswordVerify = result
  },
  // 密码是否失效
  [TYPES.USER_PASSWORDSECURITY](state, { result, type }) {
    state.userPasswordSecurity = result
  },
  // 跳转资源库
  [TYPES.RESOURCELIBRARY](state, { result, type }) {
    state.resourceLibrary = result
  },
}